<template>
  <div class="d-flex flex-column account-info mb-5 mb-lg-0">
    <Description class="mb-5 d-flex flex-column" />
    <Teams class="mb-5" />
    <Games class="mb-4" />
    <Platforms class="mb-5" />
    <Matches />
  </div>
</template>

<script>
import Description from '@/views/account/sidebarInfo/components/Description';
import Games from '@/views/account/sidebarInfo/components/Games';
import Platforms from '@/views/account/sidebarInfo/components/Platforms';
import Teams from '@/views/account/sidebarInfo/components/Teams';
import Matches from '@/views/account/sidebarInfo/components/Matches';

export default {
  name: 'AccountInfoProfile',
  components: {
    Description,
    Games,
    Platforms,
    Teams,
    Matches,
  },
};
</script>
